<template>
  <v-app dark class="gradient tw-relative">
    <div :style="`background-image: linear-gradient(180deg, rgba(0,0,0,.5) 0%, rgba(0,0,0,0) 100%), url('${backgroundUrl()}');`" class="dy-bg">
    </div>
    <div class="tw-z-10 tw-flex tw-flex-col tw-justify-between tw-min-h-[100vh]">
      <div class="tw-w-full md:tw-w-[92%] tw-mx-auto tw-relative mb-14 tw-px-4" style="filter: none !important;">
        <div>
          <Header :isMaintenance="isMaintenance"></Header>
        </div>
        <main v-if="!loading" :class="`tw-min-w-[320px] tw-rounded-md bg-main`">
          <div class="tw-p-5 tw-h-[75vh] tw-flex tw-justify-center tw-items-center ">
            <div>
              <div class="tw-text-white">
                <strong>Sorry 2EZ.BET Casino is in maintenance. Please comeback later</strong>
              </div>
              <div>
                <a @click="gotoEsports()">Go to 2EZ ESPORTS Matches</a>
              </div>
            </div>
          </div>
        </main>
      </div>
      <slot name="footer"></slot>
    </div>
  </v-app>

</template>

<script>
import { mapState } from "vuex";
import Header from "../components/Header.vue";
export default {
  props: ["isMaintenance", "loading"],
  components: {
    Header,
  },
  computed: {
    ...mapState("game", ["playBackground"]),
    isPlayRoute() {
      return this.$route.name == "Play";
    },
  },
  methods: {
    gotoEsports() {
      const url =
        process.env.VUE_APP_SERVER_ENV == "prod"
          ? process.env.VUE_APP_2EZ_URL || "https://2ez.bet"
          : "http://localhost:8000";
      window.open(url);
    },
    backgroundUrl(type = "default") {
      return this.playBackground || type == "default"
        ? this.playBackground
        : require("@/assets/images/background.jpg");
    },
  },
};
</script>

<style scoped>
.gradient {
  background: linear-gradient(
    0deg,
    rgb(114, 104, 76) 0%,
    rgb(124, 113, 83) 0%,
    rgba(41, 39, 38, 1) 100%
  ) !important;
}
.dy-bg {
  background-size: cover;
  filter: blur(5px);
  right: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.bg-main {
  background: linear-gradient(180deg, #0a0a0f 0%, #0e0e10 100%);
}
.play-glow {
  box-shadow: 0px 14px 30px 0px rgba(255, 255, 255, 0.4);
}
</style>